/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	var loadMatchingVersion = __webpack_require__(5);
	
	loadMatchingVersion();


/***/ }),
/* 1 */
/***/ (function(module, exports) {

	module.exports = {
	  scriptSource: 'https://cdn.printos.com/printos-partner-header/${version}/header.js',
	  defaults: {
	    varName: 'printos.domain'
	},
	  rules: [{
	    id: 'dev',
	    match: ['daily.gsbprint.net', 'localhost'],
	    version: "0.1.8"
	}, {
	    id: 'qual',
	    match: ['qual.printopt.org', 'pressqa.printopt.org'],
	    version: '0.1.3'
	}, {
	    id: 'migration',
	    match: 'migration.printopt.org',
	    version: '0.1.3'
	}, {
	    id: 'pressqanext',
	    match: 'pressqanext.printopt.org',
	    version: '0.1.3'
	}, {
	    id: 'next-staging',
	    match: 'stg.printopt.org',
	    version: '0.1.3'
	}, {
	    id: 'production',
	    default: true,
	    match: 'printos.com',
	    version: '0.1.3'
	}],
	};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

	// Wrapper for easily mocking globals in testing
	module.exports = {
	  window: window,
	  document: document,
	};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var globals = __webpack_require__(2);
	
	module.exports = function getWindowValue(path) {
	  if (!path) {
	    return undefined;
	  }
	
	  var object = globals.window;
	  // Split on property or array delimiters and strip out any strings
	  // returned by split.
	  var pathParts = path.split(/[.\[\]]/).filter(function(part) {
	    return part.length > 0;
	  });
	
	  for (var i = 0; i < pathParts.length; i++) {
	    var property = pathParts[i];
	    if (!(property in object)) {
	      return undefined;
	    }
	    object = object[property];
	  }
	  return object;
	};

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	module.exports = function hasMatch(source, match) {
	  if (!source || !match) {
	    return false;
	  }
	
	  // Check match.constructor instead of match.constructor.name since
	  // older browsers don't support constructor names.
	  if (match.constructor === String) {
	    return source.indexOf(match) >= 0;
	  }
	  if (match.constructor === RegExp) {
	    return match.test(source);
	  }
	
	  if (match.constructor === Array) {
	    for (var i = 0; i < match.length; i++) {
	      var m = match[i];
	      if (hasMatch(source, m)) {
	        return true;
	      }
	    }
	  }
	
	  return false;
	};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var config = __webpack_require__(1);
	var getWindowValue = __webpack_require__(3);
	var hasMatch = __webpack_require__(4);
	var loadScript = __webpack_require__(6);
	
	module.exports = function loadMatchingVersion() {
	  var rules = config.rules;
	  var defaults = config.defaults;
	  var defaultRule;
	  for (var i = 0; i < rules.length; i++) {
	    var rule = rules[i];
	    if (rule.default) {
	      defaultRule = rule;
	    }
	    var varName = rule.varName || defaults.varName;
	    var varValue = getWindowValue(varName);
	    if (hasMatch(varValue, rule.match)) {
	      return loadScript(rule.version);
	    }
	  }
	
	  // Fallback to default rule
	  return loadScript(defaultRule.version);
	};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	var globals = __webpack_require__(2);
	var config = __webpack_require__(1);
	
	module.exports = function loadScript(version) {
	  if (!version) {
	    return undefined;
	  }
	
	  var href = config.scriptSource.replace('${version}', version);
	
	  // Add preload link to increase script priority from 'Low' to 'High'.
	  // See https://developer.mozilla.org/en-US/docs/Web/HTML/Preloading_content#Scripting_and_preloads
	  var preloadLink = globals.document.createElement('link');
	  preloadLink.href = href;
	  preloadLink.rel = 'preload';
	  preloadLink.as = 'script';
	  globals.document.head.appendChild(preloadLink);
	
	  var script = globals.document.createElement('script');
	  script.src = href;
	  globals.document.head.appendChild(script);
	  return script;
	};


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// loader.js